import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgbDatepickerModule, NgbDropdownModule, NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControlModule } from '@Work/Accounts/proprietary/controls/form-controls/form-control.module';
import { InputControlModule } from '@Work/Accounts/proprietary/controls/input-control.module';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';
import { TaskActionEditPanelComponent } from './task-action/panels/task-action-edit-panel/task-action-edit-panel.component';
import { TaskActionComponent } from './task-action/task-action.component';
import { TaskHeaderComponent } from './task-header/task-header.component';
import { TaskObjectHistoryComponent } from './task-object-history/task-object-history.component';
import { TaskPropertiesEditPanelComponent } from './task-properties/panels/task-properties-edit-panel/task-properties-edit-panel.component';
import { TaskPropertiesComponent } from './task-properties/task-properties.component';

@NgModule({
    imports: [
        CommonModule,
        FormControlModule,
        SharedPageModule,
        NgbDropdownModule,
        NgbDatepickerModule,
        NgbModalModule,
        NgbTooltipModule,
        InputControlModule
    ],
    declarations: [
        TaskHeaderComponent,
        TaskActionComponent,
        TaskActionEditPanelComponent,
        TaskPropertiesComponent,
        TaskPropertiesEditPanelComponent,
        TaskObjectHistoryComponent
    ],
    exports: [
        TaskHeaderComponent,
        TaskActionComponent,
        TaskActionEditPanelComponent,
        TaskPropertiesComponent,
        TaskPropertiesEditPanelComponent,
        TaskObjectHistoryComponent,
        FormControlModule,
        InputControlModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TaskControlModule { }
